import { render, staticRenderFns } from "./LotTable.vue?vue&type=template&id=2b508bc7&scoped=true&"
import script from "./LotTable.vue?vue&type=script&lang=ts&"
export * from "./LotTable.vue?vue&type=script&lang=ts&"
import style0 from "./LotTable.vue?vue&type=style&index=0&id=2b508bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b508bc7",
  null
  
)

export default component.exports